const ascending = "ascending";
const descending = "descending";
const noSort = "noSort";

export const handleSortIconClick = (
  e,
  defaultColumnName,
  otherColumnName,
  setSortBy,
  setDefaultColumnDirection,
  defaultColumnDirection,
  otherColumnDirection,
  setOtherColumnDirection,
  columnChanged,
  callBack
) => {
  let sortById = e.target.id || e.currentTarget.id;

  switch (sortById) {
    case otherColumnName:
      const sortOrderOptions = [ascending, descending, noSort];
      const currentSortIndex = sortOrderOptions.indexOf(otherColumnDirection);
      const nextSortIndex = columnChanged
        ? 0
        : (currentSortIndex + 1) % sortOrderOptions.length;
      const nextSortDir = sortOrderOptions[nextSortIndex];

      if (nextSortDir === noSort) {
        setOtherColumnDirection(nextSortDir);
        setSortBy(defaultColumnName);
        setDefaultColumnDirection(ascending);
        callBack(ascending, defaultColumnName);
      } else {
        setOtherColumnDirection(nextSortDir);
        setSortBy(sortById);
        callBack(nextSortDir, otherColumnName);
      }
      break;

    case defaultColumnName:
      const sortDir =
        defaultColumnDirection === descending ? ascending : descending;
      setDefaultColumnDirection(sortDir);
      setSortBy(sortById);
      callBack(sortDir, defaultColumnName);
      break;

    default:
      break;
  }
};

export const filterItems = (array, { sortBy, direction }) => {
  return array.sort((a, b) => {
    const valueA = a[sortBy];
    const valueB = b[sortBy];

    if (direction === "ascending") {
      if (valueA == null) return -1;
      if (valueB == null) return 1;
    } else {
      if (valueA == null) return 1;
      if (valueB == null) return -1;
    }

    // Check if values are valid dates
    const dateA = new Date(valueA);
    const dateB = new Date(valueB);
    const isDateA = !isNaN(dateA.getTime());
    const isDateB = !isNaN(dateB.getTime());

    if (isDateA && isDateB) {
      // Both are dates, compare as timestamps
      return direction === "ascending"
        ? dateA.getTime() - dateB.getTime()
        : dateB.getTime() - dateA.getTime();
    } else {
      // Compare as strings (case-insensitive)
      const strA = String(valueA).toLowerCase();
      const strB = String(valueB).toLowerCase();

      if (strA < strB) return direction === "ascending" ? -1 : 1;
      if (strA > strB) return direction === "ascending" ? 1 : -1;
    }

    return 0; // Values are equal
  });
};
